import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ArticlePage } from "./components/shared/article-helper-components";
import Home from "./pages/home/home";
import Projects from "./pages/projects/projects";
import Articles from "./pages/articles/articles";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/articles/*" element={<Articles />} />
          <Route
            path="/articles/first_article"
            element={<ArticlePage articlenum={"1"} />}
          />
          <Route
            path="/articles/second_article"
            element={<ArticlePage articlenum={"2"} />}
          />
          <Route
            path="/articles/third_article"
            element={<ArticlePage articlenum={"3"} />}
          />
          <Route
            path="/articles/fourth_article"
            element={<ArticlePage articlenum={"4"} />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
